export default {
  DEBOUNCE_TIMER: 500, // milliseconds
  TOAST_TIMER: 2500,
};
